<template>
    <div class="public-header">
        <div class="left-view">
            <router-link
                :to="{ path: '/home' }"
                class="logo"
            >
                <div class="logo-bg"></div>

                <div class="logo-title">上海交通大学 - 励志讲坛</div>
            </router-link>
            <div class="search">
                <input
                    type="text"
                    placeholder="搜索您想要的信息"
                    v-model="searchVal"
                />
                <span class="line"></span>
                <img
                    class="icon"
                    :src="require('../assets/images/search.png')"
                    alt
                    srcset
                />
            </div>
        </div>
        <div class="right-view">
            <ul class="nav-menu">
                <li
                    v-for="(item, index) in navMenu"
                    :key="index"
                    :class="item.selected ? 'active' : ''"
                >
                    <div @click.stop="linkto(item)">{{ item.title }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { baseURL } from "../util/http";
export default {
  data() {
    return {
      navMenu: [
        {
          title: "往期回顾",
          link: "/past-view",
          selected: 0
        },
        {
          title: "关于讲坛",
          link: "/about-pulpit",
          selected: 0
        },
        {
          title: "联系我们",
          link: "/about-us",
          selected: 0
        },
        {
          title: "我参加的",
          link: "/myattend",
          selected: 0
        }
      ],
      searchVal: ""
    };
  },
  created() {
    this.initState();
  },
  watch: {
    $route(to, from) {
      document.body.scrollTop = 0;
      this.initState();
    }
  },
  methods: {
    initState() {
      this.navMenu.map(item => {
        item.selected = item.link === this.$route.path;
        return item;
      });
    },
    linkto(item) {
      location.href = item.link;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../minxin.less";
@import "../theme.less";

.public-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  height: 80px;
  background-color: @layout-header-bg;
  padding: 0;
  padding-left: 12%;
  padding-right: 10%;
  display: flex;
  justify-content: space-between;
  .left-view {
    .flex-between-center();
    .logo {
      .flex-between-center();
      &-bg {
        background-image: url("../assets/images/Home_logo.png");
        background-repeat: no-repeat;
        width: 40px;
        height: 40px;
        background-size: contain;
      }
      &-title {
        color: #fff;
        margin-left: 10px;
      }
    }
    .search {
      margin-left: 40px;
      position: relative;
      .icon {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 30px;
        margin: auto;
        &:hover {
          cursor: pointer;
        }
      }
      input {
        border-radius: @border-base-radius;
        background-color: rgba(255, 255, 255, 0.3);
        padding: 6px 21px;
        padding-right: 60px;
        width: 257px;
        color: #fff;
        &::-webkit-input-placeholder {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.3);
        }
      }
      &::after {
        content: " ";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 60px;
        margin: auto;
        width: 1px;
        height: 70%;
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
  .right-view {
    .nav-menu {
      display: flex;
      align-items: center;
      padding: 0;
      li {
        margin-right: 40px;
        &.active {
          div {
            color: #fff;
            &::after {
              width: 70%;
            }
          }
        }
        > div {
          cursor: pointer;
          color: rgba(255, 255, 255, 0.3);
          transition: all 0.3s;
          position: relative;
          &:hover {
            color: #fff;
            &::after {
              width: 70%;
            }
          }
          &::after {
            content: " ";
            position: absolute;
            top: 24px;
            left: 0;
            right: 0;
            width: 0;
            height: 4px;
            background: #fff;
            margin: auto;
            border-radius: 3px;
            transition: all 0.3s;
          }
        }
      }
    }
  }
}
@media screen and (max-device-width: 480px) {
  .logo {
    .logo-title {
      display: none;
    }
  }
}
</style>
